// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__U7TnT","label":"Radio_label__2s5sO","checkMark":"Radio_checkMark__l5P85","disabled":"Radio_disabled__20kHD"};